import { createContext } from "react";
import { GetCheckboxData } from "@shared/common/CardsList/types";

export interface ContextProps<T extends object> {
  isEditMode: boolean;
  setIsEditMode: (clickedItem: any) => void;
  getCheckboxProps: GetCheckboxData<T>;
}

export const CardsSelectorContext = createContext<
  ContextProps<any> | undefined
>(undefined);
